import { render, staticRenderFns } from "./VoteConfirmed.vue?vue&type=template&id=319eac22"
import script from "./VoteConfirmed.vue?vue&type=script&lang=js"
export * from "./VoteConfirmed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports